export default "__VITE_ASSET__b8b46643__"